import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { FilterSolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/FilterSolicitudAmpliacionSsoModel';
import { SolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/SolicitudAmpliacionSsoModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterSolicitudAmpliacionSsoModel } from 'src/app/models/interfaces/calendario-sso/IFilterSolicitudAmpliacionSsoModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SolicitudAmpliacionSsoService } from 'src/app/services/solicitud-ampliacion-sso/solicitud-ampliacion-sso.service';
import { SsoAmpliacionAprobacionDialogComponent } from '../sso-ampliacion-aprobacion-dialog/sso-ampliacion-aprobacion-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  templateUrl: './sso-ampliacion-historial-solicitudes.component.html',
  styleUrls: ['./sso-ampliacion-historial-solicitudes.component.css']
})
export class SsoAmpliacionHistorialSolicitudesComponent implements OnInit {
  listaMeses: Mes[] = [
    {value: '1', viewValue: 'Enero'},
    {value: '2', viewValue: 'Febrero'},
    {value: '3', viewValue: 'Marzo'},
    {value: '3', viewValue: 'Abril'},
    {value: '1', viewValue: 'Mayo'},
    {value: '2', viewValue: 'Junio'},
    {value: '3', viewValue: 'Julio'},
    {value: '3', viewValue: 'Agosto'},
    {value: '1', viewValue: 'Setiembre'},
    {value: '2', viewValue: 'Octubre'},
    {value: '3', viewValue: 'Noviembre'},
    {value: '3', viewValue: 'Diciembre'},
  ];
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaTipos: ParametroModel[] = new Array<ParametroModel>();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  listaAnios: Number[] = new Array<Number>();
  resultsLength = 0;
  currentPage = 0;
  model: IFilterSolicitudAmpliacionSsoModel = new FilterSolicitudAmpliacionSsoModel();
  displayedColumns: string[] = ['anio', 'mes', 'sede', 'empresa', 'tipo', 'fechaCreacion', 'solicitante','estado', 'fechalimite','aprobador'];
  listaSolicitudes: SolicitudAmpliacionSsoModel[] = new Array<SolicitudAmpliacionSsoModel>();
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private storage: StorageService,
    public dialog: MatDialog,
    private sedeService: SedeService,
    private parametroService: ParametroService,
    private calendarioService: CalendarioSsoService,
    private service: SolicitudAmpliacionSsoService) { 
      let usuario = this.storage.getCurrentUser();
      this.listaCompanias = usuario.companias;
      this.model.idCompania = usuario.companiaDefault.idCompania;
    }

  ngOnInit(): void {
    this.companiaChanged();
      this.parametroService
        .getDetalles(ParametrosMaestro.TIPO_SOLICITUD_AMPLIACION)
        .subscribe((p) => {
          this.listaTipos = p.items;
        });
        this.parametroService
          .getDetalles(ParametrosMaestro.ESTADOS_SOLICITUD_AMPLIACION)
          .subscribe((p) => {
            this.listaEstados = p.items;
          });
          this.calendarioService.getAnios()
          .subscribe((data: number[]) => {
            this.listaAnios = data;
          });
    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    this.model.pageSize = 30;
    this.service
      .getList(this.model)
      .subscribe((data: SearchResultModel<SolicitudAmpliacionSsoModel[]>) => {
        this.listaSolicitudes = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
        // this.resultsLength = data.total;
        // this.currentPage = 0;
        //this.paginator.firstPage();
      });
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.service
      .exportList(this.model)
      .subscribe(data => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob:any = data.body;// new Blob([data.body], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        
        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `solicitudes-ampliacion-sso-${Date.now()}.xlsx`);

      //  this.createImageFromBlob(data);
      //  this.isImageLoading = false;
     }, error => {
      //  this.isImageLoading = false;
      //  console.log(error);
     });
  }
  
  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    // this.serviceSede
    //   .getListFiltered(this.filter)
    //   .subscribe((data) => {
    //     this.model = data;
    //     this.resultsLength = data.total;
    //   });
  }
  openDialogAprobacion(): void {
    
    
    const dialogRef = this.dialog.open(SsoAmpliacionAprobacionDialogComponent, {
      width: '700px',
    });

    // dialogRef.afterClosed().subscribe((result: PersonalDialogModel) => {
      
    // });
  }
}
interface Mes {
  value: string;
  viewValue: string;
}